import { useContext } from 'react';
import { ApplicationContext } from '../ApplicationContext';
// eslint-disable-next-line no-unused-vars
import BankbookAnimationStore from '../stores/BankbookAnimationStore';
/**
 * This hook returns the bank record store.
 * @return {BankbookAnimationStore}
 */
const useBankbookAnimationStore = () => {
	const context = useContext(ApplicationContext);
	const { applicationStore } = context;
	const { bankbookAnimationStore } = applicationStore;

	return bankbookAnimationStore;
};

export default useBankbookAnimationStore;
